'use client';

import { getBaseUrl } from 'eco-design-reliance/getBaseUrl';
import { getReqHeaders } from '../utils/getReqHeaders';
import { getCToken } from '../utils/token';

// web 端
export const fetchGet = async (url: string, locale: string, params: any, options?: any) => {
    const API_HOST = getBaseUrl(locale);
    const options2 = options || {};
    const headers1 = getReqHeaders(locale);
    const headers2 = options2.headers || {};
    // 需要登录
    const token = getCToken();
    if (options2.needToken && token) {
        headers1['Authorization'] = `Bearer ${token}`;
    }
    const res = await fetch(`${API_HOST}${url}`, {
        method: 'GET',
        headers: {
            ...headers1,
            ...headers2,
        },
        next: { revalidate: 300 },
    });

    return res.json();
};

// web 端
export const fetchPost = async (url: string, locale: string, params: any, options?: any) => {
    const API_HOST = getBaseUrl(locale);
    const options2 = options || {};
    const headers1 = getReqHeaders(locale);
    const headers2 = options2.headers || {};
    // 需要登录
    const token = getCToken();
    if (options2.needToken && token) {
        headers1['Authorization'] = `Bearer ${token}`;
    }
    headers1['Accept'] = 'application/json';
    headers1['Content-Type'] = 'application/json';
    const res = await fetch(`${API_HOST}${url}`, {
        method: 'POST',
        headers: {
            ...headers1,
            ...headers2,
        },
        body: JSON.stringify(params || {}),
        next: { revalidate: 300 },
    });

    return res.json();
};

// put
export const fetchPut = async (url: string, locale: string, params: any, options?: any) => {
    const API_HOST = getBaseUrl(locale);
    const options2 = options || {};
    const headers1 = getReqHeaders(locale);
    const headers2 = options2.headers || {};
    // 需要登录
    if (options2.needToken) {
        const token = getCToken();
        headers1['Authorization'] = `Bearer ${token}`;
    }
    headers1['Accept'] = 'application/json';
    headers1['Content-Type'] = 'application/json';

    const res = await fetch(`${API_HOST}${url}`, {
        method: 'PUT',
        headers: {
            ...headers1,
            ...headers2,
        },
        body: JSON.stringify(params || {}),
        next: { revalidate: 300 },
    });

    return res.json();
};
